import experience from "./experience";

export const EXPERIENCE_NAMESPACE = `users/experience`;

export default experience;
